'use client'

import dynamic from 'next/dynamic'

export const SubscriptionsClientPage = dynamic(
  () => import('./subscriptions-page-content').then(module => module.SubscriptionsPageContent),
  {
    ssr: false,
  },
)
